import { SUPPORTED_LANGUAGES } from '../constants/languages';
import type { SupportedLanguage, TranslationKey } from '../types/i18nTypes';

/**
 * Load all translations from JSON files in /public/locales/
 */
export async function loadTranslations(): Promise<
    Record<SupportedLanguage, TranslationKey>
> {
    const translations: Record<SupportedLanguage, TranslationKey> = {
        [SUPPORTED_LANGUAGES.NB]: {},
        [SUPPORTED_LANGUAGES.NN]: {},
        [SUPPORTED_LANGUAGES.EN_GB]: {},
    };

    // Load in parallel
    const loadPromises = Object.values(SUPPORTED_LANGUAGES).map(
        async (lang): Promise<void> => {
            try {
                const response = await fetch(
                    `/locales/${lang}/translation.json`,
                );
                if (!response.ok) {
                    throw new Error(`Failed to load translations for ${lang}`);
                }
                translations[lang as SupportedLanguage] = await response.json();
            } catch (error) {
                console.warn(`Could not load translations for ${lang}:`, error);
                // Use empty translations if it fails
                translations[lang as SupportedLanguage] = {};
            }
        },
    );

    await Promise.all(loadPromises);
    return translations;
}
